import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';
import { content, footnote } from '@ux/type-size';
import { percentage } from '@ux/style-utils';

export default ({
  theme,
}) => {
  const {
    spacing,
    typography,
    palette,
  } = theme;

  return {
    default: {
      root: {
        display: 'block',
        wordBreak: 'break-word',
        marginBottom: 0,
        fontWeight: 'normal',
        height: percentage(100),
      },
      panel: {
        ...cssSides('padding', Side.A, gu2px(3, spacing)),
        height: percentage(100),
      },
      toggle: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      title: {
        ...content(typography),
        color: palette.primary,
        paddingRight: gu2px(2, spacing),
        ...cssSides('margin', Side.Y, 0),
        fontWeight: 600,
      },
      text: {
        marginBottom: 0,
        marginTop: gu2px(2, spacing),
        ...footnote(typography),
        color: palette.grey04,
      },
    },

    canOptOut: {
      root: {
        cursor: 'pointer',
      },
    },
  };
};
